import Vue from 'vue'
import VueRouter from 'vue-router'
import resize from 'vue-element-resize-detector'

Vue.use(VueRouter)
Vue.use(resize)

const routes = [
  {
    path: '/',
    name: 'Home Page',
    component: () => import('../views/client/_login/login.vue'),
    meta: { Language: true }
  },
  {
    path: '/:lang(en|ja|zh-tw|zh-cn)?',
    name: 'Home',
    component: () => import('../views/client/_login/login.vue'),
    meta: { Login: true }
  },
  {
    path: '/administrator/login',
    name: 'Login',
    component: () => import('../views/login/login_admin.vue'),
    meta: { LoginAdmin: true }
  },
  {
    path: '/administrator/forgot-pass',
    name: 'Forget Password',
    component: () => import('../views/forget_password/forget_pass.vue')
  },
  {
    path: '/admin/new-password',
    name: 'New Password',
    component: () => import('../views/forget_password/new-password.vue')
  },
  {
    path: '/administrator/dashboard',
    name: 'Admin Dashboard',
    component: () => import('../views/admin/admin_dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/memberList',
    name: 'Admin Member List',
    component: () => import('../views/admin/member_list.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/new-member',
    name: 'Add New Memeber',
    component: () => import('../views/admin/new_member.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-member/:id',
    name: 'Edit Member',
    component: () => import('../views/admin/edit_member.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/admin-list',
    name: 'List of Administrators',
    component: () => import('../views/admin/admin_list.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/admin-register',
    name: 'Administrator registration',
    component: () => import('../views/admin/admin_register.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-admin-super/:id',
    name: 'Edit Administration (Super Authority)',
    component: () => import('../views/admin/edit_admin_super.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/property-list/:type',
    name: 'Property List',
    component: () => import('../views/property/property_list.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/new-property/:type',
    name: 'Add New Property',
    component: () => import('../views/property/new_property.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-property/:type/:id/:language',
    name: 'Edit Property Information',
    component: () => import('../views/property/edit_property.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/blog-list',
    name: 'Blog List',
    component: () => import('../views/blog/blog_list.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/new-blog',
    name: 'Add New Blog',
    component: () => import('../views/blog/new_blogArticles.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-blog/:id',
    name: 'Blog Editing',
    component: () => import('../views/blog/edit_blog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-blog/:id/:language',
    name: 'Blog Editing Language',
    component: () => import('../views/blog/edit_blog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/email-list',
    name: 'Email List',
    component: () => import('../views/_email/email_list.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/new-email',
    name: 'Create new email',
    component: () => import('../views/_email/new_email.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/administrator/edit-email/:id',
    name: 'E-mail magazine editing',
    component: () => import('../views/_email/edit_email.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:lang/administrator/password/reset/:token',
    name: 'Verify Token',
    component: () => import('../views/forget_password/verifyForgotPass.vue')
  },
  {
    path: '/:lang/client/login',
    name: 'Client Login',
    component: () => import('../views/client/_login/login.vue'),
    meta: { Login: true }
  },
  {
    path: '/:lang/client/entry',
    name: 'Client Entry',
    component: () => import('../views/client/_entry/entry.vue')
  },
  {
    path: '/:lang/client/entry-thanks',
    name: 'Client Entry Thanks',
    component: () => import('../views/client/_entry/entry-thanks.vue')
  },
  {
    path: '/:lang/client/entry-detail',
    name: 'Client Entry Detail',
    component: () => import('../views/client/_entry/entry-detail.vue'),
    meta: { memberPreRegister: true }
  },
  {
    path: '/:lang/client/entry-detail-thanks',
    name: 'Client Entry Detail Thanks',
    component: () => import('../views/client/_entry/entry-detail-thanks.vue')
  },
  {
    path: '/:lang/client/forgot-password',
    name: 'Client Forgot Password',
    component: () => import('../views/client/_forgot_password/forgot-password.vue')
  },
  {
    path: '/:lang/member/password/reset/:token',
    name: 'Verify Token Client',
    component: () => import('../views/client/_forgot_password/verifyForgotPass.vue')
  },
  {
    path: '/:lang/client/forgot-password-confirmation',
    name: 'Client Forgot Password Confirmation',
    component: () => import('../views/client/_forgot_password/forgot-password-confirmation.vue')
  },
  {
    path: '/:lang/client/reset-password',
    name: 'Client Reset Password',
    component: () => import('../views/client/_reset_password/reset-password.vue')
  },
  {
    path: '/:lang/client/reset-password-confirmation',
    name: 'Client Reset Password Confirmation',
    component: () => import('../views/client/_reset_password/reset-password-confirmation.vue')
  },
  {
    path: '/:lang/client/404',
    name: 'Client 404',
    component: () => import('../views/client/404.vue')
  },
  {
    path: '*',
    name: 'Client Global 404',
    component: () => import('../views/client/404.vue')
  },
  {
    path: '/:lang/client/blog-detail/:id',
    name: 'Client Blog Detail',
    component: () => import('../views/client/article/article-detail.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/blog-list',
    name: 'Client Blog List',
    component: () => import('../views/client/article/article-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/contact',
    name: 'Client Contact',
    component: () => import('../views/client/contact/contact.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/contact-confirmation',
    name: 'Client Contact Confirmation',
    component: () => import('../views/client/contact/contact-confirmation.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/home',
    name: 'Client Property',
    component: () => import('../views/client/property/property.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/property-list',
    name: 'Client Property List',
    component: () => import('../views/client/property/property-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/property-list/:sold',
    name: 'Client Sold Property List',
    component: () => import('../views/client/property/property-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/property-list-prefecture',
    name: 'Client Property Map',
    component: () => import('../views/client/property/propertyMap.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/property-list-prefecture/:prefecture',
    name: 'Client Prefecture Property List',
    component: () => import('../views/client/property/property-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/property-detail/:id',
    name: 'Client Property Detail',
    component: () => import('../views/client/property/property-detail.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/rental/:type',
    name: 'rental-property-list',
    component: () => import('../views/client/property/property-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/rental/:type/:id',
    name: 'rental-property-detail',
    component: () => import('../views/client/property/property-detail.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/member-information',
    name: 'Client Member Information',
    component: () => import('../views/client/member/member-information.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/member-information-update',
    name: 'Client Member Information Update',
    component: () => import('../views/client/member/member-information-update.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/plan-information',
    name: 'plan-information',
    component: () => import('../views/client/member/plan-information.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/business-property/list',
    name: 'business-property-list',
    component: () => import('../views/client/member/business-property-list.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/business-property/create',
    name: 'business-property-create',
    component: () => import('../views/client/member/business-property-create.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/business-property/edit/:id',
    name: 'business-property-edit',
    component: () => import('../views/client/member/business-property-edit.vue'),
    meta: { requiresMemberAuth: true }
  },
  {
    path: '/:lang/client/withdrawal-procedure-completed',
    name: 'Client Withdrawal Completed',
    component: () => import('../views/client/member/withdrawal-procedure-completed.vue')
  },
  {
    path: '/:lang/member/registration/:password',
    name: 'Entry Verify',
    component: () => import('../views/client/_entry/verifyEntry.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})
router.afterEach((to, from) => {
  // TODO: frontend/src/views/client/property/property-detail.vue でもデフォルトタイトルをハードコーディングしているので共通化したい
  document.title = 'GLOCALY JAPAN'
})
router.beforeEach((to, from, next) => {
  const authenticatedAdmin = Vue.$cookies.get('access_token_admin')
  const authenticated = Vue.$cookies.get('access_token_client')
  var locale = null
  var address = []
  var location = null
  const IsItABackButton = window.popStateDetected

  if (IsItABackButton) {
    window.popStateDetected = false
    locale = Vue.$cookies.get('language')
    if (locale) {
      locale = locale.toString()
      address = window.location.pathname.split('/')
      if (locale !== address[1]) {
        address = address.join('/')
        window.location.reload()
      }
    }
  } else {
    address = window.location.pathname.split('/')
    location = address[1]

    switch (location) {
      case 'en':
        location = 'en'
        break
      case 'zh-tw':
        location = 'zh-tw'
        break
      case 'zh-cn':
        location = 'zh-cn'
        break
      default:
        location = 'ja'
        break
    }
    Vue.$cookies.set('language', location)
  }

  if (to.meta.requiresAuth) {
    if (!authenticatedAdmin) {
      return next({ name: 'Login' })
    } else {
      return next()
    }
  } else if (to.meta.Login) {
    if (authenticated) {
      return next({ name: 'Client Property', params: { lang: 'ja' } })
    } else {
      return next()
    }
  } else if (to.meta.LoginAdmin) {
    if (authenticatedAdmin) {
      return next({ name: 'Admin Dashboard' })
    } else {
      return next()
    }
  } else if (to.meta.requiresMemberAuth) {
    if (!authenticated) {
      return next({ name: 'Client Login', params: { lang: location, redirect: window.location.pathname } })
    } else {
      return next()
    }
  } else if (to.meta.Language) {
    return next({ name: 'Home', params: { lang: 'ja' } })
  } else {
    return next()
  }
})

export default router
